import React, { useEffect, useState } from "react";
import 'firebase/compat/auth';
import { GoogleBtn } from "./GoogleBtn";
import { connect } from "react-redux";
import { setUser } from "../actions/mainActions";
import getFirebase, { getDbInterfaceAuth } from "../firebase";
import { DEV_TOKEN_KEY, getDevToken, isDevMode } from "./utils/commHelper";
import DbInterfaceSessionGate from "./DbInterface/session/dbInterfaceSessionGate";

const DevTokenForm = ({ onSubmit }) => {
  const [token, setToken] = useState("");
  return (
    <div style={{ maxWidth: 480, margin: "40px auto", fontFamily: "sans-serif" }}>
      <h3>Dev login</h3>
      <p style={{ color: "#666", fontSize: 13 }}>
        Paste a Firebase ID token to use for API calls (development only).
      </p>
      <textarea
        value={token}
        onChange={(e) => setToken(e.target.value)}
        placeholder="Paste token here"
        rows={4}
        style={{ width: "100%", fontFamily: "monospace", fontSize: 12, padding: 8 }}
      />
      <button
        onClick={() => {
          const trimmed = token.trim();
          if (trimmed) onSubmit(trimmed);
        }}
        style={{
          marginTop: 8,
          padding: "8px 16px",
          backgroundColor: "#1976d2",
          color: "white",
          border: "none",
          borderRadius: 4,
          cursor: "pointer",
        }}
      >
        Use token
      </button>
    </div>
  );
};

// `requireFreshSession` (DB Interface): ignore the cached localStorage user and gate on the
// live, per-tab Firebase session instead — every new tab asks for a Google sign-in and the
// session ends after one hour (see DbInterfaceSessionGate). The Printer dashboard keeps the
// original behaviour.
const Login = ({ children, user, setUser, requireFreshSession = false }) => {
  // if (typeof window !== "undefined") {
  //   getFirebase()
  // }

  // Track dev-token bypass so we can re-render once a token is provided.
  const [hasDevToken, setHasDevToken] = useState(!!getDevToken());

  useEffect(() => {
    // Dev mode uses a pasted ID token and never needs the Firebase SDK locally
    // (env often has no valid REACT_APP_FIREBASE_* → auth/invalid-api-key).
    if (!isDevMode()) {
      try {
        getFirebase();
        if (requireFreshSession) getDbInterfaceAuth();
      } catch (e) {
        console.warn("[Login] Firebase init failed:", e?.message || e);
      }
    }
    if (requireFreshSession) return;
    const userLocalStorage = localStorage.getItem("user");
    if (userLocalStorage) {
      setUser(JSON.parse(userLocalStorage));
    }
  }, [setUser, requireFreshSession]);

  // In development, bypass Google login entirely: prompt for a token and use
  // it for API calls (see commHelper.jsx). This takes priority over any stored
  // Firebase user, since Firebase auth may be unreachable in dev.
  if (isDevMode()) {
    if (hasDevToken) {
      return (
        <div>
          {children}
          <button
            onClick={() => {
              localStorage.removeItem(DEV_TOKEN_KEY);
              setHasDevToken(false);
            }}
            title="Clear the dev token and re-enter it"
            style={{
              position: "fixed",
              bottom: 8,
              right: 8,
              zIndex: 99999,
              padding: "4px 8px",
              fontSize: 11,
              backgroundColor: "#dc3545",
              color: "white",
              border: "none",
              borderRadius: 4,
              cursor: "pointer",
              opacity: 0.7,
            }}
          >
            Reset dev token
          </button>
        </div>
      );
    }
    return (
      <DevTokenForm
        onSubmit={(token) => {
          localStorage.setItem(DEV_TOKEN_KEY, token);
          setHasDevToken(true);
        }}
      />
    );
  }

  if (requireFreshSession) {
    return <DbInterfaceSessionGate>{children}</DbInterfaceSessionGate>;
  }

  return (
    <div>
      {user?.uid ? (
        children
      ) : (
        <GoogleBtn
          isSuccess={(newUser) => {
            setUser(newUser);
          }}
        />
      )}
    </div>
  );
};

const mapStateToProps = ({ MainReducer }) => {
  return { user: MainReducer.user };
};

export default connect(mapStateToProps, { setUser })(Login);
